import React, { useState } from 'react'

const TEXT = 'Resort fees are payable directly to the hotel upon arrival.'

const ResortFeeDialog = () => {
  const [open, setOpen] = useState(false)

  const _openResortFeeDialog = () => setOpen(!open)

  return (
    <div className="resort-fee toggle-slide-wrapper">
      <em>* excludes daily&nbsp;
        <button
          className="plain text"
          onClick={_openResortFeeDialog}>resort fee</button>
      </em>
      <aside className={`toggle-slide ${open ? "open" : ""}`}>
        {TEXT}
      </aside>
    </div>
  )
}

export default ResortFeeDialog
